import {
  appSync,
  fetchEvents,
  startListening,
  socketConnected,
} from '@bonanza-social/toolkit/state';
import {
  fetchStatus,
  selectIsNewLoyalty,
  selectStatus,
  updateStatus,
  statusBoxClaimed,
  statusChanged,
  acknowledgeStatus,
  statusChangedLegacy,
} from './status.slice';
import { BottomSheet } from '@bonanza-social/navigation';
import { navigationRef } from '@bonanza-social/navigation';
import { StatusUpdatedEventData } from './status.types';
import { ASSET_PRELOADERS } from '../../utils/status';

startListening({
  actionCreator: appSync,
  effect: (_, { dispatch }) => {
    dispatch(fetchStatus());
  },
});

startListening({
  actionCreator: fetchEvents.fulfilled,
  effect: ({ payload }) => {
    const { events } = payload;

    events.forEach((event) => {
      const preloaderKey =
        event.type === 'Onboarding' ? event.type : event.details?.statusState;

      if (preloaderKey) {
        ASSET_PRELOADERS[preloaderKey]();
      }
    });
  },
});

startListening({
  actionCreator: socketConnected,
  effect: (action, { dispatch, getState }) => {
    const socketConnection = action.payload;
    socketConnection.on('StatusProgress', (data: StatusUpdatedEventData) => {
      const { pendingRewards, ...rest } = data;
      const parsedPendingRewards = pendingRewards.map(
        ({ playerRewardId, ...reward }) => ({
          ...reward,
          rewardId: playerRewardId,
        }),
      );

      // statusBoxClaimed and statusChanged are used to fetch coin balance on gem collected or new status
      const status = selectStatus(getState());

      if (status?.playerStatus !== data.playerStatus) {
        dispatch(statusChangedLegacy());
      }

      if (status && status.rewardStrategy === 'Auto') {
        if (status.playerStatus !== data.playerStatus) {
          dispatch(statusChanged());
        } else if (
          Number(data.claimedBoxesCount) > Number(status.claimedBoxesCount)
        ) {
          dispatch(statusBoxClaimed());
        }
      }

      dispatch(updateStatus({ pendingRewards: parsedPendingRewards, ...rest }));
    });
  },
});

startListening({
  actionCreator: updateStatus,
  effect: (action, { dispatch, getState }) => {
    const status = action.payload;
    const isNewLoyalty = selectIsNewLoyalty(getState());

    if (status.playerStatusState.match('ToBePromoted|ToBeDemoted|ToBeKept')) {
      if (!isNewLoyalty) {
        BottomSheet.open({
          namespace: 'status',
          type: 'statusUpdated',
          data: {
            variant: status.playerStatusState,
            status,
          },
          borderGradient: `status${status.playerStatus}Background`,
          headerImageName: `status.${status.playerStatus}Badge`,
          borderStyle: 'allsides',
          // TODO: Fix TS
          onInfo: () => navigationRef.navigate('StatusInfo'),
          scrollable: true,
        });

        dispatch(acknowledgeStatus());
        return;
      }

      // dispatch(fetchEvents());
      dispatch(acknowledgeStatus());
    }
  },
});
